var React = require('react');

function IconStack (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Stack"),React.createElement("g",{"fill":"currentColor","fillRule":"nonzero","key":1},[React.createElement("path",{"d":"M11.03 2.105L2.104 6.827l8.926 4.722 8.927-4.722-8.927-4.722zm.984-1.861l8.926 4.722c1.494.79 1.494 2.932 0 3.722l-8.926 4.722a2.103 2.103 0 0 1-1.967 0L1.121 8.688c-1.495-.79-1.495-2.932 0-3.722L10.047.244a2.103 2.103 0 0 1 1.967 0z","key":0}),React.createElement("path",{"d":"M1.542 10.648a1.052 1.052 0 1 0-.98 1.863l9.994 5.264c.307.161.673.161.98 0l9.994-5.264a1.053 1.053 0 0 0-.98-1.863l-9.504 5.006-9.504-5.006z","key":1}),React.createElement("path",{"d":"M1.542 14.859a1.052 1.052 0 1 0-.98 1.863l9.994 5.264c.307.161.673.161.98 0l9.994-5.264a1.053 1.053 0 0 0-.98-1.863l-9.504 5.005-9.504-5.005z","key":2})])]);
}

IconStack.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = IconStack;

IconStack.default = IconStack;
